import state from './moduleExperienciesState'
import mutations from './moduleExperienciesMutations'
import actions from './moduleExperienciesActions'
import getters from './moduleExperienciesGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}